import * as React from 'react'

import { Text, spacing } from '@thg-commerce/gravity-theme'

import { NavigationItem } from '../../NavigationTree/index'
import { styled } from '../../../theme'

const NavigationList = styled.ul`
  list-style-type: none;
`

const StyledHeader = styled.div`
  background: transparent;
  border: 2px solid transparent;
  padding: ${spacing(1)} calc(${spacing(1)} - 2px);
  margin: ${spacing(1)} ${spacing(-1)};

  &:focus-within {
    border: 2px solid ${(props) => props.theme.colors.palette.brand.base};
  }
  
  &:hover {
    ${(props) =>
      `background: ${props.theme.patterns.header.navigation.dropdownHeaderHover.hoverBackgroundColor};`}

  /* DO NOT GROUP WITH ABOVE BREAKS POLYFILL FOR MSOFT BROWSERS */
  &.focus-within {
    border: 2px solid ${(props) => props.theme.colors.palette.brand.base};
  }
  &:hover {
    ${(props) =>
      `background: ${props.theme.patterns.header.navigation.dropdownHeaderHover.hoverBackgroundColor};`}
  }
`

const StyledHeaderLink = styled.a`
  background: transparent;
  ${(props) =>
    Text(
      props.theme.patterns.header.navigation.dropdownHeaderFont.entry,
      props.theme.patterns.header.navigation.dropdownHeaderFont.style,
    )};
  outline: none;
  text-decoration: ${(props) =>
    props.theme.patterns.header.navigation.dropdownHeaderFont.textDecoration};
  color: ${(props) =>
    props.theme.patterns.header.navigation.dropdownHeaderFont.textColor};
  text-transform: ${(props) =>
    props.theme.patterns.header.navigation.dropdownHeaderFont.transform};

  &:hover {
    ${(props) =>
      props.theme.patterns.header.navigation.dropdownHeaderHover
        .hoverBackgroundColor === '#FFFFFF' && 'text-decoration: underline;'}
  }
`

const LinkWrapper = styled.li`
  display: flex;
  padding: calc(${spacing(0.5)} - 2px) calc(${spacing(1)} - 2px);
  margin: 0 ${spacing(-1)};
  border: 2px solid transparent;
  &:focus-within {
    border: 2px solid ${(props) => props.theme.colors.palette.brand.base};
  }
  &:hover {
    ${(props) =>
      props.theme.patterns.header.navigation.linkHover.hoverBackgroundColor !==
        '#FFFFFF' &&
      `background: ${props.theme.patterns.header.navigation.linkHover.hoverBackgroundColor};`}
    a {
      color: ${(props) =>
        props.theme.patterns.header.navigation.linkHover.hoverLinkFont
          .textColor};
    }
  }

  /* DO NOT GROUP WITH ABOVE BREAKS POLYFILL FOR MSOFT BROWSERS */
  &.focus-within {
    border: 2px solid ${(props) => props.theme.colors.palette.brand.base};
  }
  &:hover {
    ${(props) =>
      props.theme.patterns.header.navigation.linkHover.hoverBackgroundColor !==
        '#FFFFFF' &&
      `background: ${props.theme.patterns.header.navigation.linkHover.hoverBackgroundColor};`}
  }
`

const SubNavigationLink = styled.a`
  width: 100%;
  ${(props) =>
    Text(
      props.theme.patterns.header.navigation.linkFont.entry,
      props.theme.patterns.header.navigation.linkFont.style,
    )};
  color: ${(props) =>
    props.theme.patterns.header.navigation.linkFont.textColor};
  outline: none;
  text-decoration: ${(props) =>
    props.theme.patterns.header.navigation.linkFont.textDecoration};
  text-transform: ${(props) =>
    props.theme.patterns.header.navigation.linkFont.transform};

  &:hover {
    ${(props) =>
      props.theme.patterns.header.navigation.linkHover.hoverBackgroundColor ===
        '#FFFFFF' && 'text-decoration: underline;'}
    ${(props) =>
      Text(
        props.theme.patterns.header.navigation.linkHover.hoverLinkFont.entry,
        props.theme.patterns.header.navigation.linkHover.hoverLinkFont.style,
      )};
    color: ${(props) =>
      props.theme.patterns.header.navigation.linkHover.hoverLinkFont.textColor};
    text-decoration: ${(props) =>
      props.theme.patterns.header.navigation.linkHover.hoverLinkFont
        .textDecoration};
    text-transform: ${(props) =>
      props.theme.patterns.header.navigation.linkHover.hoverLinkFont.transform};
  }

  &:active {
    ${(props) =>
      Text(
        props.theme.patterns.header.navigation.linkFont.entry,
        props.theme.patterns.header.navigation.linkFont.style,
      )};
  }
`

const SubNavigationColumnWrapper = styled.div<{
  columnWidth: string
}>`
  flex-basis: calc(${(props) => props.columnWidth});
`

const SubNavColumnInnerContainer = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  margin: ${spacing(1)} ${spacing(2)} ${spacing(2)} ${spacing(2)};
`

const SubNavColumnFeaturedInnerContainer = styled.div`
  padding-top: ${spacing(2)};
`

const ColumnsFlexWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-basis: calc(5 * (100% / 6));
`

const getSubnavigationLinks = (
  subNavsSubNavs,
  colIndex,
  topLevelName,
  focusHandler,
) =>
  subNavsSubNavs.map((el, index) => {
    if (el.link) {
      return (
        <LinkWrapper
          key={`subnavigation-link-${index}`}
          data-testid={'subnavigation-link'}
        >
          <SubNavigationLink
            href={el.link?.url}
            data-nav-name={`${topLevelName}`}
            data-nav-index={`${colIndex},${index + 1}`}
            onFocus={() => {
              focusHandler(colIndex, index + 1)
            }}
          >
            {el.displayName}
          </SubNavigationLink>
        </LinkWrapper>
      )
    }
    return null
  })

const SubNavigationColumn = (
  subNav: NavigationItem,
  colIndex: number,
  topLevelName: string,
  focusHandler: (arg1: number, arg2: number) => void,
  featuredColumn: boolean,
  dynamicWidthSize?: string,
) => {
  const width = (() => {
    if (featuredColumn) {
      return '100% / 5'
    }
    if (dynamicWidthSize) {
      return dynamicWidthSize
    }
    return '100% / 6'
  })()

  if (subNav.type !== 'FEATURED') {
    return (
      <SubNavigationColumnWrapper
        key={`sub-nav-column-${colIndex}`}
        data-testid={'sub-nav-column'}
        columnWidth={width}
      >
        <SubNavColumnInnerContainer>
          <StyledHeader>
            <StyledHeaderLink
              href={subNav.link?.url}
              data-nav-name={`${topLevelName}`}
              data-nav-index={`${colIndex},${0}`}
              onFocus={() => {
                focusHandler(colIndex, 0)
              }}
            >
              {subNav.displayName}
            </StyledHeaderLink>
          </StyledHeader>
          {subNav.subNavigation && (
            <NavigationList aria-labelledby={subNav.id}>
              {getSubnavigationLinks(
                subNav.subNavigation,
                colIndex,
                topLevelName,
                focusHandler,
              )}
            </NavigationList>
          )}
        </SubNavColumnInnerContainer>
      </SubNavigationColumnWrapper>
    )
  }
  return null
}

const NavContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: ${spacing(2)} ${spacing(2)};
  width: auto;
`

interface TextNavContentProps {
  item: NavigationItem
  dynamicWidth: boolean
}

export const TextNavigationContent = ({
  item,
  dynamicWidth,
}: TextNavContentProps) => {
  const [activeNavIndex, setActiveNavIndex] = React.useState([-1, -1])

  const onKeyDown = (event: React.KeyboardEvent) => {
    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault()
        const leftElement = (document.querySelector(
          `[data-nav-name="${item.displayName}"][data-nav-index="${
            activeNavIndex[0] - 1
          },${activeNavIndex[1]}"]`,
        ) ||
          document.querySelector(
            `[data-nav-name="${item.displayName}"][data-nav-index="${
              activeNavIndex[0] - 1
            },${activeNavIndex[1] + 1}"]`,
          )) as HTMLElement
        if (leftElement) {
          leftElement.focus()
        } else if (
          document.querySelector(
            `[data-nav-name="${item.displayName}"][data-nav-index="${
              activeNavIndex[0] - 1
            },0"]`,
          ) as HTMLElement
        ) {
          let closestEl
          let index = activeNavIndex[1] - 1
          while (!closestEl) {
            closestEl = document.querySelector(
              `[data-nav-name="${item.displayName}"][data-nav-index="${
                activeNavIndex[0] - 1
              },${index}"]`,
            ) as HTMLElement
            index -= 1
          }
          closestEl.focus()
        }
        break
      case 'ArrowUp':
        event.preventDefault()
        const aboveElement = document.querySelector(
          `[data-nav-name="${item.displayName}"][data-nav-index="${
            activeNavIndex[0]
          },${activeNavIndex[1] - 1}"]`,
        ) as HTMLElement
        if (aboveElement) {
          aboveElement.focus()
        } else if (
          (document.querySelector(
            `[data-nav-name="${item.displayName}"][data-nav-index="${
              activeNavIndex[0] - 1
            },0"]`,
          ) ||
            document.querySelector(
              `[data-nav-name="${item.displayName}"][data-nav-index="${
                activeNavIndex[0] - 1
              },1"]`,
            )) as HTMLElement
        ) {
          let closestEl = (document.querySelector(
            `[data-nav-name="${item.displayName}"][data-nav-index="${
              activeNavIndex[0] - 1
            },0"]`,
          ) ||
            document.querySelector(
              `[data-nav-name="${item.displayName}"][data-nav-index="${
                activeNavIndex[0] - 1
              },1"]`,
            )) as HTMLElement
          for (let startingIndex = 0; startingIndex <= 1; startingIndex += 1) {
            let index = startingIndex
            while (closestEl) {
              const candidateClosestEl = document.querySelector(
                `[data-nav-name="${item.displayName}"][data-nav-index="${
                  activeNavIndex[0] - 1
                },${index}"]`,
              ) as HTMLElement

              if (candidateClosestEl) {
                closestEl = candidateClosestEl
                index += 1
              } else {
                break
              }
            }
          }
          closestEl.focus()
        }
        break
      case 'ArrowRight':
        event.preventDefault()
        const rightElement = document.querySelector(
          `[data-nav-name="${item.displayName}"][data-nav-index="${
            activeNavIndex[0] + 1
          },${activeNavIndex[1]}"]`,
        ) as HTMLElement
        if (rightElement) {
          rightElement.focus()
        } else if (
          document.querySelector(
            `[data-nav-name="${item.displayName}"][data-nav-index="${
              activeNavIndex[0] + 1
            },0"]`,
          ) as HTMLElement
        ) {
          let closestEl
          let index = activeNavIndex[1] - 1
          while (!closestEl) {
            closestEl = document.querySelector(
              `[data-nav-name="${item.displayName}"][data-nav-index="${
                activeNavIndex[0] + 1
              },${index}"]`,
            ) as HTMLElement
            index -= 1
          }
          closestEl.focus()
        }
        break
      case 'ArrowDown':
        event.preventDefault()
        const belowElement = document.querySelector(
          `[data-nav-name="${item.displayName}"][data-nav-index="${
            activeNavIndex[0]
          },${activeNavIndex[1] + 1}"]`,
        ) as HTMLElement
        belowElement
          ? belowElement.focus()
          : (document.querySelector(
              `[data-nav-name="${item.displayName}"][data-nav-index="${
                activeNavIndex[0] + 1
              },0"]`,
            ) as HTMLElement)?.focus()
        break
      default:
        break
    }
  }

  const focusHandler = (colIndex, rowIndex) => {
    setActiveNavIndex([colIndex, rowIndex])
  }

  const firstSubNav = item?.subNavigation?.[0]
  const featuredColumn = item?.subNavigation?.[0].type === 'FEATURED' && (
    <SubNavigationColumnWrapper
      key={`sub-nav-column-0`}
      data-testid={'sub-nav-column'}
      columnWidth={'100% / 6'}
    >
      <SubNavColumnFeaturedInnerContainer>
        {firstSubNav?.subNavigation && (
          <NavigationList aria-labelledby={firstSubNav?.id}>
            {getSubnavigationLinks(
              firstSubNav?.subNavigation,
              0,
              item.displayName,
              focusHandler,
            )}
          </NavigationList>
        )}
      </SubNavColumnFeaturedInnerContainer>
    </SubNavigationColumnWrapper>
  )
  const dynamicWidthSize =
    dynamicWidth &&
    item?.subNavigation?.length &&
    item?.subNavigation?.length < 6
      ? `100% / ${item?.subNavigation?.length}`
      : ''
  const navColumns = item?.subNavigation?.map((subNav, index) => {
    return SubNavigationColumn(
      subNav,
      index,
      item.displayName,
      focusHandler,
      !!featuredColumn,
      dynamicWidthSize,
    )
  })

  if (featuredColumn) {
    return (
      <NavContent onKeyDown={onKeyDown}>
        {featuredColumn}
        <ColumnsFlexWrapper>{navColumns}</ColumnsFlexWrapper>
      </NavContent>
    )
  }
  return <NavContent onKeyDown={onKeyDown}>{navColumns}</NavContent>
}
